import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const TISA_FOREX_RATE_CATEGORY = `${API_URL}/tisa-forex-rate-category`

export const service = {
  getTisaForexRateCategory: (params: ParamsModel) => {
    return axios.get(TISA_FOREX_RATE_CATEGORY, {params})
  },

  getAllTisaForexRateCategory: (params: ParamsModel) => {
    return axios.get(`${TISA_FOREX_RATE_CATEGORY}/all`, {params})
  },

  getSingleTisaForexRateCategory: (id: string) => {
    return axios.get(`${TISA_FOREX_RATE_CATEGORY}/${id}`)
  },

  addTisaForexRateCategory: (data: any) => {
    return axios.post(TISA_FOREX_RATE_CATEGORY, data)
  },

  updateTisaForexRateCategory: (body: any, id: string) => {
    return axios.patch(`${TISA_FOREX_RATE_CATEGORY}/${id}`, body)
  },

  deleteTisaForexRateCategory: (categoryIds: Array<{id: string}>) => {
    return axios.delete(`${TISA_FOREX_RATE_CATEGORY}/destroy`, {
      data: {categoryIds},
    })
  },

  singleActivateTisaForexRateCategory: (categoryIds: Array<{id: string}>) => {
    return axios.patch(`${TISA_FOREX_RATE_CATEGORY}/enable`, {categoryIds})
  },

  singleDeactivateTisaForexRateCategory: (categoryIds: Array<{id: string}>) => {
    return axios.patch(`${TISA_FOREX_RATE_CATEGORY}/disable`, {categoryIds})
  },
}
